import DragAndDropUploader from 'components/ReusableComponents/DragAndDropUploader'
import { createWidgetFileUploadProcess } from 'features/EmailEditor/emailImageUploadHelpers'
import useClickOut from 'hooks/useClickOut'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import widgetsApi from 'services/api/widgets'

import fileUplaoderStyles from './FileUploaderDialog.module.scss'

const FileUploaderDialog = ({
  onClickout,
  onLoad,
  onData,
  onUpdateFiles,
  onClickRecentFile,
  onRecentFilesReady,
  kind,
  allowImageValidateSize = false,
  imageValidateSizeMinWidth = 0,
  imageValidateSizeMinHeight = 0,
  refreshRecentFilesOnUpload = false,
  top,
  left
}) => {
  const wrapperRef = useRef()

  useClickOut(wrapperRef, onClickout)

  const [recentFiles, setRecentFiles] = useState([])

  const [isLoading, setIsLoading] = useState(true)

  const loadRecentFiles = () => {
    setIsLoading(true)

    return widgetsApi.files.get(kind).then(data => {
      const files = Array.isArray(data) ? data.filter(Boolean) : []
      setRecentFiles(files)
      if (onRecentFilesReady) {
        onRecentFilesReady(files)
      }
      setIsLoading(false)
    })
  }

  useEffect(() => {
    loadRecentFiles()
  }, [kind])

  function handleUploadLoad(response) {
    onLoad(response)

    if (refreshRecentFilesOnUpload) {
      loadRecentFiles()
    }
  }

  return (
    <div className={fileUplaoderStyles.wrapper} ref={wrapperRef} style={{ top, left }}>
      <div className={fileUplaoderStyles.dragAndDropHolder}>
        <MemoizedDragAndDropUploader
          onLoad={handleUploadLoad}
          onData={onData}
          onUpdateFiles={onUpdateFiles}
          kind={kind}
          allowImageValidateSize={allowImageValidateSize}
          imageValidateSizeMinWidth={imageValidateSizeMinWidth}
          imageValidateSizeMinHeight={imageValidateSizeMinHeight}
        />
      </div>
      {!isLoading && recentFiles?.length > 0 && (
        <>
          <p className={fileUplaoderStyles.recentFilesTitle}>Select from recent files</p>
          <div className={fileUplaoderStyles.recentFiles}>
            {recentFiles
              ?.reverse()
              ?.slice(0, 5)
              ?.map(file => (
                <div
                  key={file}
                  onClick={() => onClickRecentFile(file)}
                  className={fileUplaoderStyles.recentFile}
                  style={{ backgroundImage: `url(${file})` }}
                />
              ))}
          </div>
        </>
      )}
    </div>
  )
}

const MemoizedDragAndDropUploader = React.memo(
  ({
    onUpdateFiles,
    onData,
    onLoad,
    kind,
    allowImageValidateSize,
    imageValidateSizeMinWidth,
    imageValidateSizeMinHeight
  }) => {
    const serverProcess = useMemo(
      () =>
        createWidgetFileUploadProcess({
          kind,
          onUploadStart: onData,
          onLoad
        }),
      [kind, onData, onLoad]
    )

    return (
      <DragAndDropUploader
        acceptedFileTypes={['image/*']}
        maxFiles={1}
        onUpdateFiles={onUpdateFiles}
        serverProcess={serverProcess}
        allowImageValidateSize={allowImageValidateSize}
        imageValidateSizeMinWidth={imageValidateSizeMinWidth}
        imageValidateSizeMinHeight={imageValidateSizeMinHeight}
        labelIdle="
<p class='filepond-p-mini'>drop a file here</p>
<span class='filepond-or'>or</span> <span class='filepond--label-action-mini'>Select file</span>"
      />
    )
  }
)

export default FileUploaderDialog
